// Resolve the cloud path using the existing owner-scoped metadata, trail and listing APIs.
function compareNodes(left,right,sort){
 if(!left||!right||!left.kind||!right.kind)return null
 if((left.kind==='DIR')!==(right.kind==='DIR'))return left.kind==='DIR'?-1:1
 const timestamp=value=>typeof value==='number'?value:Date.parse(String(value).replace(' ','T'))
 const a=timestamp(left.createdAt),b=timestamp(right.createdAt)
 if(!Number.isFinite(a)||!Number.isFinite(b))return null
 const direction=sort==='CREATED_ASC'?1:-1
 if(a!==b)return (a<b?-1:1)*direction
 const first=String(left.id),second=String(right.id)
 if(!/^\d+$/.test(first)||!/^\d+$/.test(second))return null
 return (first.length!==second.length?(first.length<second.length?-1:1):first===second?0:first<second?-1:1)*direction
}

export default {
 data:()=>({locating:false,locationGeneration:0,locatedNode:null}),
 watch:{ownerId(){this.cancelLocation();this.locatedNode=null},'space.ownerId'(){this.cancelLocation();this.locatedNode=null}},
 beforeDestroy(){this.cancelLocation()},
 methods:{
  cancelLocation(){this.locationGeneration++;this.locating=false},
  nodeLocated(row){return this.locatedNode&&this.mode==='files'&&!this.keyword&&String(this.locatedNode.parentId)===String(this.parentId)&&String(this.locatedNode.id)===String(row.id)},
  driveRowClass(args){return [this.uploadRowClass(args),this.nodeLocated(args.row)?'drive-located':''].filter(Boolean).join(' ')},
  async directoryPage(parentId,node,sort,current){
   // Keep the same 50-item pages and directory-first order as normal browsing. Never search by
   // name here: OCR hits need not match the name, and different directories can share names.
   const pages=new Map(),found=list=>list.records.some(row=>String(row.id)===String(node.id))
   const read=async page=>{
    if(!current())return null
    const list=pages.get(page)||{...await this.request('/nodes',{parentId,status:'ACTIVE',sort,page,size:50}),page}
    if(!current())return null
    pages.set(page,list);return list
   }
   const first=await read(1)
   if(!first)return null
   if(found(first))return first
   const maximum=Math.min(100000,Math.ceil(Number(first.total)/50))
   let low=2,high=maximum,fallback=compareNodes(node,first.records[0],sort)===null
   // The API uses kind, creation time and ID as a stable total order. Locate large directories
   // in logarithmic requests; older responses without timestamps retain a sequential fallback.
   while(!fallback&&low<=high){
    const page=Math.floor((low+high)/2),list=await read(page)
    if(!list)return null
    if(found(list))return list
    const before=compareNodes(node,list.records[0],sort),after=compareNodes(node,list.records[list.records.length-1],sort)
    if(before===null||after===null){fallback=true;break}
    if(before<0)high=page-1
    else if(after>0)low=page+1
    else break
   }
   // Timestamp serialization may lose subsecond precision, and concurrent uploads can shift page
   // boundaries. If the ordered lookup misses, inspect remaining pages before reporting a move.
   for(let page=2;page<=maximum;page++){
    const list=await read(page)
    if(!list)return null
    if(found(list))return list
    if(!list.records.length)break
   }
   throw Error('文件或目录的位置已变化，请刷新后重试')
  },
  async revealInDrive(row){
   if(row.pending||this.mode==='trash')return
   this.contextMenu=null;clearTimeout(this.searchTimer)
   const location=++this.locationGeneration,generation=++this.generation,owner=this.columnOwner()
   const current=()=>!this.disposed&&location===this.locationGeneration&&generation===this.generation&&owner===this.columnOwner()
   this.columnGeneration++;this.loading=false;this.locating=true
   try{
    let node=row,trail
    if(row.kind==='DIR'){
     const path=await this.request('/trail',{parentId:row.id})
     if(!current())return
     node=path[path.length-1]
     if(!node||String(node.id)!==String(row.id))throw Error('目录位置已变化，请刷新后重试')
     trail=path.slice(0,-1)
    }else{
     node=await this.request('/attachments/'+row.id)
     if(!current())return
     trail=await this.request('/trail',{parentId:node.parentId||0})
     if(!current())return
    }
    const parentId=node.parentId||0,sort=['CREATED_ASC','CREATED_DESC'].includes(this.sort)?this.sort:'CREATED_DESC'
    const list=await this.directoryPage(parentId,node,sort,current)
    if(!current())return
    const path=[{id:0,name:'全部文件'},...trail],columns=[]
    // Cache each opened level, including its actual page. Switching views later keeps this path.
    for(let index=0;index<path.length;index++){
     const folder=path[index],last=index===path.length-1,selectedId=last?null:path[index+1].id
     const contents=last?list:await this.directoryPage(folder.id,path[index+1],sort,current)
     if(!current())return
     columns.push({parentId:folder.id,name:folder.name,selectedId,rows:contents.records,page:contents.page,
      total:contents.total,loading:false,error:'',tree:true,requestGeneration:0})
    }
    this.mode='files';this.keyword='';this.tagId=null;this.sort=sort;this.parentId=parentId
    this.page=list.page;this.rows=list.records;this.total=list.total;this.trail=trail;this.error=''
    this.locatedNode={id:node.id,parentId};this.columnSelection={id:node.id,parentId}
    this.columns=columns;this.columnSignature=JSON.stringify([this.ownerId,this.space.ownerId,this.mode,this.keyword,this.tagId,this.sort])
    await this.syncColumns()
    if(current())this.$nextTick(()=>{if(current())this.scrollLocatedNode()})
   }catch(error){if(current())this.report(error)}
   finally{if(location===this.locationGeneration)this.locating=false}
  },
  scrollLocatedNode(){
   if(!this.locatedNode||!this.$el)return
   const elements=this.$el.querySelectorAll('[data-drive-reveal-node]')
   for(const element of elements){
    const located=element.getAttribute('data-drive-reveal-node')===String(this.locatedNode.id)
    if(element.offsetParent!==null&&(located||element.classList.contains('selected'))){
     element.scrollIntoView({block:'nearest',inline:'nearest'})
    }
   }
  }
 }
}
